<!-- <template>
  <div>
    <el-date-picker
      type="month"
      @change="onChange"
      v-model="submit_data[data.key]"
      v-bind="date_attrs"
      :placeholder="data.desc">
    </el-date-picker>
  </div>
</template>
<script>
  import Common from './js/Common'

  var Js = Common('sls-date-month')
  Js.mixins = [{
    computed: {
      date_attrs () {
        return this.Data.date_attrs || {}
      }
    },
    methods: {
      onChange (v) {
        this.events.change && this.events.change(v)
      }
    }
  }]
  export default Js
</script>
 -->

<template>
  <div>
    <el-date-picker
      @change="onChange"
      v-model="dtrange_defaultValue"
      type="month"
      value-format="timestamp"
      range-separator="至"
      :placeholder="fieldArguments.placeholder">
    </el-date-picker>
  </div>
</template>
<script>
  import Common from './js/Common'

  var Js = Common('sls-date-month')
  Js.mixins = [{
    data () {
      return {
        dtrange_defaultValue:[]
      }
    },
    mounted () {
      this.dtrange_defaultValue = this.defaultValue;
    },
    computed: {
      date_time_attrs () {
        return this.Data.date_time_attrs || {}
      }
    },
    methods: {

    },
    watch: {
      defaultValue () {

        this.dtrange_defaultValue = this.defaultValue
      },
    }
  }]
  export default Js
</script>



// WEBPACK FOOTER //
// src/components/solely-fields/SlsDateMonth.vue